/**
 * Popup
 *
 * Script to display popup after amount of ms.
 * Saves state to user's session. Uses popup-id to allow for several popup states.
 * Takes existing cookiebar into consideration. Popup doesn't show until cookies are accepted.
 *
 * Example HTML:
 *
 * <div class="popup js-popup" data-popup-ms="300" data-popup-id="unique-id">
 * 	<div data-popup-close></div>
 * </div>
 */
const timeOutMsFallback = 300;
const sessionKey = 'popup';
const fallbackElementPopupId = 'generic';
const cookiebotAcceptButtonId = 'CybotCookiebotDialogBodyButtonAccept';

const init = function() {
	const $els = document.querySelectorAll('.js-popup');
	if ($els.length === 0) {
		return;
	}

	const getElementSessionKey = function($el) {
		return `${sessionKey}-${$el.getAttribute('data-popup-id') || fallbackElementPopupId}`;
	};

	const showPopup = function($el) {
		$el.classList.add('is-active');
	};

	const closePopup = function($el) {
		// Save state to session
		sessionStorage.setItem(getElementSessionKey($el), true);
		// Remove popup
		$el.classList.remove('is-active');
	};

	const registerCloseListener = function($el) {
		const $close = $el.querySelector('[data-popup-close]');
		if ($close) {
			$close.addEventListener('click', () => {
				closePopup($el);
			});
		}
	};

	const registerSubmitListener = function($el) {
		const $form = $el.querySelector('form');
		$form.addEventListener('submit', () => {
			// When user succesfully submits, save state to session.
			// Either submission will refresh page or user can click close button
			// Don't force closing of popup
			const $errors = $form.querySelectorAll('.is-error');
			if ($errors.length === 0) {
				sessionStorage.setItem(getElementSessionKey($el), true);
			}
		});
	};

	const setupTimer = function() {
		$els.forEach($el => {
			const elSessionKey = getElementSessionKey($el);
			// Check state in session
			const state = sessionStorage.getItem(elSessionKey);
			if (!state) {
				// Register close listener
				registerCloseListener($el);
				// Register submit listener
				registerSubmitListener($el);
				// Set timeout for showing popup
				const timeOutMs = $el.getAttribute('data-popup-ms') || timeOutMsFallback;
				window.setTimeout(() => {
					showPopup($el);
				}, timeOutMs);
			}
		});
	};

	// Takes existing cookiebar into consideration. Popup doesn't show until cookies are accepted.
	const $cookiebotAcceptButton = document.querySelector(`#${cookiebotAcceptButtonId}`);
	if ($cookiebotAcceptButton) {
		$cookiebotAcceptButton.addEventListener('click', setupTimer);
	} else {
		window.addEventListener('load', setupTimer);
	}
};

module.exports = {
	init
};
